import { ArrowLeft, Building2, Phone, QrCode, RotateCcw, Save, Star, Users } from 'lucide-react';
import { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from '../../../assets/scss/pages/SettingsPage.module.scss';
import { useInvoiceSettings } from '../../../hooks/useInvoiceSettings';

const CONTENT_ITEMS = [
    {
        key: 'showShopInfo',
        icon: <Building2 />,
        label: 'Thông tin cửa hàng',
        desc: 'Tên, SĐT, địa chỉ cửa hàng ở đầu hoá đơn',
    },
    {
        key: 'showCustomerPhone',
        icon: <Phone />,
        label: 'Số điện thoại khách',
        desc: 'Hiện SĐT khách hàng trên hoá đơn in',
    },
    {
        key: 'showCustomerLoyaltyPoint',
        icon: <Star />,
        label: 'Điểm tích lũy khách',
        desc: 'Hiện điểm tích lũy hiện tại của khách',
    },
    {
        key: 'showSupportEmployee',
        icon: <Users />,
        label: 'Nhân viên hỗ trợ',
        desc: 'Hiện tên nhân viên phục vụ cho từng dịch vụ',
    },
    {
        key: 'showPaymentQr',
        icon: <QrCode />,
        label: 'QR thanh toán',
        desc: 'Hiện mã QR chuyển khoản ngân hàng trên hoá đơn',
    },
];

export default function InvoiceSettings() {
    const navigate = useNavigate();
    const { settings, updateSettings, resetDefaults } = useInvoiceSettings();
    const [draft, setDraft] = useState({ ...settings });
    const [toast, setToast] = useState(null);

    const showToast = useCallback((type, text) => {
        setToast({ type, text });
        setTimeout(() => setToast(null), 1800);
    }, []);

    const onToggle = (key) => {
        setDraft((prev) => ({ ...prev, [key]: !prev[key] }));
    };

    const hasChanges = CONTENT_ITEMS.some((item) => draft[item.key] !== settings[item.key]);

    const handleSave = () => {
        updateSettings(draft);
        showToast('success', 'Đã lưu cài đặt hoá đơn');
    };

    const handleReset = () => {
        resetDefaults();
        setDraft({ showShopInfo: true, showCustomerPhone: true, showCustomerLoyaltyPoint: true, showSupportEmployee: true, showPaymentQr: true });
        showToast('success', 'Đã khôi phục mặc định');
    };

    return (
        <div className={styles.page}>
            {/* Header */}
            <div className={styles.header}>
                <button className={styles.backBtn} onClick={() => navigate(-1)}>
                    <ArrowLeft size={18} />
                </button>
                <div>
                    <h1 className={styles.title}>Cài đặt hoá đơn</h1>
                    <div className={styles.subtitle}>Chọn nội dung hiển thị khi in hoá đơn</div>
                </div>
            </div>

            <div className={styles.content}>
                {/* Content items */}
                <div className={styles.section}>
                    <div className={styles.sectionHeader}>
                        <div className={styles.sectionTitle}>Nội dung hiển thị trên hoá đơn</div>
                    </div>
                    {CONTENT_ITEMS.map((item) => (
                        <div key={item.key} className={styles.item}>
                            <div className={styles.itemLeft}>
                                <div className={styles.itemIcon}>{item.icon}</div>
                                <div>
                                    <div className={styles.itemLabel}>{item.label}</div>
                                    <div className={styles.itemDesc}>{item.desc}</div>
                                </div>
                            </div>
                            <label className={`${styles.toggle} ${draft[item.key] ? styles.toggleOn : ''}`}>
                                <input
                                    type="checkbox"
                                    checked={!!draft[item.key]}
                                    onChange={() => onToggle(item.key)}
                                />
                                <span className={styles.toggleTrack} />
                            </label>
                        </div>
                    ))}
                </div>

                {/* Footer actions */}
                <div className={styles.footer}>
                    <button className={styles.btnReset} onClick={handleReset}>
                        <RotateCcw size={15} />
                        Mặc định
                    </button>
                    <button className={styles.btnSave} onClick={handleSave} disabled={!hasChanges}>
                        <Save size={15} />
                        {hasChanges ? 'Lưu thay đổi' : 'Không có thay đổi'}
                    </button>
                </div>
            </div>

            {/* Toast */}
            {toast && (
                <div className={`${styles.toast} ${toast.type === 'success' ? styles.toastSuccess : styles.toastError}`}>
                    {toast.text}
                </div>
            )}
        </div>
    );
}
